export default __webpack_public_path__ + "static/media/contactus.ccae12d4.svg";